import LoginLink from "./LoginLink";
import LoginLinkCode from "./LoginLinkCode";
import { connect } from "react-redux";

export const LoginLinkCodePage = connect()(LoginLinkCode);

export default connect()(LoginLink);
